"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gray_1 = __importDefault(require("./gray"));
const blue_1 = __importDefault(require("./blue"));
const orange_1 = __importDefault(require("./orange"));
const rose_1 = __importDefault(require("./rose"));
const teal_1 = __importDefault(require("./teal"));
const purple_1 = __importDefault(require("./purple"));
const red_1 = __importDefault(require("./red"));
const palette = {
    common: {
        black: "#000",
        white: "#fff",
    },
    status: {
        success: "#2e7d32",
        warning: orange_1.default[50],
        error: red_1.default[70],
    },
    text: {
        primary: gray_1.default[100],
        secondary: gray_1.default[70],
        disabled: gray_1.default[30],
    },
    primary: {
        light: blue_1.default[30],
        main: blue_1.default[50],
        dark: blue_1.default[80],
    },
    accent: {
        light: purple_1.default[50],
        main: purple_1.default[70],
        dark: purple_1.default[90],
    },
    gray: gray_1.default,
    blue: blue_1.default,
    orange: orange_1.default,
    rose: rose_1.default,
    teal: teal_1.default,
    purple: purple_1.default,
    red: red_1.default,
};
exports.default = palette;
//# sourceMappingURL=index.js.map